import {Component, OnInit} from '@angular/core';
import {StoryboardService} from '../storyboard/shared/storyboard.service';
import {Storyboard} from 'storyboard-renderer';
import {ActivatedRoute} from '@angular/router';
import { from } from 'rxjs/observable/from';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-storyboard-publish',
    templateUrl: './storyboard-publish.component.html',
    styleUrls: ['./storyboard-publish.component.scss']
})
export class StoryboardPublishComponent implements OnInit {
    numberInQueue: number = 0;
    MODES: any = {
        MORE_THEN_ONE_IN_QUEUE: 'moreThenOneInQueue',
        ONE_IN_QUEUE: 'oneInQueue',
        STARTING_UP: 'startingUp',
        LESS_25_PERCENTS: 'less25percents',
        BETWEEN_25_90_PERCENTS: 'between25_90percents',
        MORE_THAN_90_PERCENT: 'moreThan90percents',
        FINALIZING: 'finalizing',
    };
    mode: string = '';
    framesDone: number = 0;
    amountOfFrames: number = 0;
    progress: any = '0%';

    storyboard: Storyboard;
    storyboardLoading = true;

    public storyboardId;
    rendering = true;
    success = true;
    dabSuccess = true;
    renderingDab = false;

    showGenerateDab: boolean = true;
    disableGenerateDabButton: boolean = false;
    public checkingSubscription: Subscription;

    private readonly checkingTime = 2 * 1000; // 10 seconds to check the rendering status
    private readonly requestErrorTimeout = 10 * 1000;
    private readonly requestTimeout = 30 * 1000;

    constructor(private storyboardService: StoryboardService, private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.storyboardId = +params['id']; // (+) converts string 'id' to a number
            this.getStoryboard(this.storyboardId);
        });
    }

    getStoryboard(storyboardId: number): void {

        this.storyboardLoading = true;

        this.storyboardService.getStoryboard(storyboardId).then(storyboard => {
            this.checkRenderStatus(storyboard);
            this.storyboard = storyboard;
            if (storyboard.last_dab_export){
                if (storyboard.last_dab_export.rendering_status !== 'new' && storyboard.last_dab_export.rendering_status !== 'completed') {
                    this.renderingDab = true;
                }

                if (storyboard.last_dab_export.rendering_status === 'completed') {
                    this.renderingDab = false;
                    this.showGenerateDab = false;
                }
            }

            if (storyboard.last_video_export) {
                if (storyboard.last_video_export.convertation.pending) {
                    this.rendering = true;
                } else {
                    this.rendering = false;
                    this.success = storyboard.last_video_export.convertation.success === true;
                }

                if (this.rendering === true) {
                    setTimeout(() => this.startChecking(), this.checkingTime);
                }
            }

            this.storyboardLoading = false;
        }, () => {
            this.storyboardLoading = false;
        });
    }

    startChecking() {
        const timeout = setTimeout(() => {
            this.checkingSubscription.unsubscribe();
            this.startChecking();
        }, this.requestTimeout);

        let checkEnd = false;

        this.checkingSubscription = this.storyboardService.getStoryboardAsObservable(this.storyboardId).subscribe(storyboard => {
            clearTimeout(timeout);
            this.checkingSubscription.unsubscribe()
            this.checkRenderStatus(storyboard);
            if (storyboard.last_video_export) {
                if (storyboard.last_video_export.convertation.completed) {
                    this.storyboard = storyboard;
                    this.rendering = false;
                    this.success = storyboard.last_video_export.convertation.success === true;
                    checkEnd = true;
                    this.setMode('');
                }
            }

            if (!checkEnd) {
                setTimeout(() => this.startChecking(), this.checkingTime);
            }

        }, () => {
            clearTimeout(timeout);
            setTimeout(() => this.startChecking(), this.requestErrorTimeout);
        });
    }

    startCheckingAfterDabGenerate() {
        let checkEnd = false;

        this.storyboardService.getStoryboard(this.storyboardId).then(storyboard => {
            if (storyboard.last_dab_export) {
                if (storyboard.last_dab_export.rendering_status === 'completed') {
                    this.storyboard = storyboard;
                    this.renderingDab = false;
                    this.showGenerateDab = false;
                    this.dabSuccess = storyboard.last_dab_export.rendering_status === 'completed';
                    checkEnd = true;
                }
            }

            if (!checkEnd) {
                setTimeout(() => this.startCheckingAfterDabGenerate(), this.checkingTime);
            }

        });
    }

    fetchStoryBoardAfterDabGenerated(storyboardId: number): void {
        this.storyboardService.getStoryboard(storyboardId).then(storyboard => {

            this.storyboard = storyboard;

            if (storyboard.last_dab_export) {
                if (storyboard.last_dab_export.rendering_status != 'completed') {
                    this.renderingDab = true;
                } else {
                    this.renderingDab = false;
                    this.showGenerateDab = false;
                    this.dabSuccess = storyboard.last_dab_export.rendering_status === 'completed';
                }

                if (this.storyboard.last_dab_export.rendering_status === 'pending'
                    || this.storyboard.last_dab_export.rendering_status === 'rendering') {
                    setTimeout(() => this.startCheckingAfterDabGenerate(), this.checkingTime);
                }
            }

            this.storyboardLoading = false;
        }, () => {
            this.storyboardLoading = false;
        });
    }

    downloadVideo() {
        window.open(this.storyboard.last_video_export.sources[0].download_url, '_blank');
    }

    downloadDAB() {
        window.open(this.storyboard.last_dab_export.download_url, '_blank');
    }

    generateDAB() {
        this.disableGenerateDabButton = true;
        this.storyboardService.publishDab(this.storyboard.id, this.storyboard.user.id)
            .then((res) => {
                console.log(res);
                this.fetchStoryBoardAfterDabGenerated(this.storyboard.id);
            })
    }

    setMode(mode) {
        this.mode = mode;
    }

    checkRenderStatus(storyboard) {
        if (storyboard && storyboard.last_video_export.convertation.number_in_queue) {
            const numberInQueue = storyboard.last_video_export.convertation.number_in_queue;
            if (numberInQueue > 1) {
                this.setMode(this.MODES.MORE_THEN_ONE_IN_QUEUE);
                this.numberInQueue = numberInQueue;
            }
            if(numberInQueue === 1) {
                this.setMode(this.MODES.ONE_IN_QUEUE);
                this.numberInQueue = 0;
            }
        }

        if (storyboard && storyboard.last_video_export.convertation.in_progress) {
            this.amountOfFrames = storyboard.last_video_export.convertation.total_frames;
            this.framesDone = storyboard.last_video_export.convertation.current_frame;

            //TODO need to delete after backend amount of frames issue fixed
            if (this.amountOfFrames < this.framesDone) {
                this.framesDone = this.amountOfFrames;
            }

            // Total Frames can be 0 at the beginning and need to prevent NaN
            this.progress = Math.ceil((this.framesDone / this.amountOfFrames) * 100) || 0;

            if (this.progress == 0) {
                this.setMode(this.MODES.STARTING_UP);
            }
            else if (this.progress <= 25) {
                this.setMode(this.MODES.LESS_25_PERCENTS);
            }
            else if ((this.progress >= 26) && (this.progress < 100)) {
                this.setMode(this.MODES.BETWEEN_25_90_PERCENTS);
            }
            else if (this.progress == 100) {
                this.setMode(this.MODES.FINALIZING)
            }

            this.progress = this.progress + '%'
        }

        if (this.storyboard && storyboard.last_video_export.convertation.completed && storyboard.last_video_export.convertation.success) {
            this.setMode('');
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/storyboard-publish/storyboard-publish.component.ts